/* product-editorial-video.js */
(function () {
  var videos = document.querySelectorAll('.pev__video');
  if (!videos.length) return;

  videos.forEach(function (video) {
    video.muted = true;
    video.playsInline = true;
    video.loop = true;

    /* Intentar reproducir directo */
    var playPromise = video.play();

    if (playPromise !== undefined) {
      playPromise.catch(function () {
        /* Si falla (política del navegador), usar IntersectionObserver */
        var observer = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              video.play().catch(function () {});
            } else {
              video.pause();
            }
          });
        }, { threshold: 0.25 });

        observer.observe(video);
      });
    }
  });
})();